import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Video.css";
import { FaShoppingCart, FaCheckCircle } from "react-icons/fa";
import DarsVideoPlayer from "../Kurs/DarsVideoPlayer";
import { toast } from "react-toastify";
import CONFIG from "../config";
import { formatSumma } from "../utils/format";
import CoursePurchaseModal from "./CoursePurchaseModal";

function Video({ kurs, userData, refreshUserData, handleLogout }) {
  const navigate = useNavigate();
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // "Ready" logic based on original design: HTML(7)-Vue(12) and Python(19)-Laravel(23)
  const isReady =
    (kurs.id >= 7 && kurs.id <= 12) || (kurs.id >= 19 && kurs.id <= 23);

  const narx = parseFloat(kurs.narx || 0);
  const isFree = narx === 0;
  // Check for both properties to be safe, prioritizing sotib_olingan as used in Loyiha.js
  const isPurchased = kurs.sotib_olingan || kurs.is_purchased;

  const handlePurchase = async (promoCode = "", showToast = true) => {
    setIsProcessing(true);
    try {
      const token = localStorage.getItem("loyiha_token");
      const res = await fetch(`${CONFIG.API_BASE_URL}/buy_kurs.php?token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          kurs_id: kurs.id,
          promo_code: typeof promoCode === 'string' ? promoCode : ""
        })
      }).then(r => r.json());

      if (res.status === 'success') {
        if (refreshUserData) await refreshUserData();

        const targetUrl = `/kurs-dars/${kurs.nomi.toLowerCase().replace(/ /g, "-")}`;

        if (showToast) {
          toast.success("Tabriklaymiz! Kurs muvaffaqiyatli sotib olindi. Mantiqiy masalalarga xush kelibsiz!", {
            icon: "🚀",
            autoClose: 2500
          });

          // Delay only for actual new purchases to show the toast
          setTimeout(() => {
            navigate(targetUrl);
          }, 2500);
        } else {
          // Direct navigation for free/already owned courses
          navigate(targetUrl);
        }
      } else {
        toast.error(res.message);
        if (res.message.includes('Token')) handleLogout();
      }
    } catch (err) {
      toast.error("Xarid qilishda xatolik yuz berdi");
    } finally {
      setIsProcessing(false);
      setShowPurchaseModal(false);
    }
  };

  const onBuyClick = () => {
    if (isPurchased) {
      // Already purchased - go straight into the course
      navigate(`/kurs-dars/${kurs.nomi.toLowerCase().replace(/ /g, "-")}`);
      return;
    }

    if (isFree) {
      // Free courses - call API silently to record access, then enter
      handlePurchase("", false);
      return;
    }

    // Robust balance check for paid content
    const balance = userData ? parseFloat(userData.tanga_balansi || 0) : 0;
    if (!userData || balance < narx) {
      toast.error("Hisobingizda yetarli tanga mavjud emas!");
      return;
    }

    // Show confirmation modal for actual purchase
    setShowPurchaseModal(true);
  };

  return (
    <div className="qiymat-quti-scroll">
      <div className="qiymat-mavzu-quti" onContextMenu={(e) => e.preventDefault()}>
        <div className="course-price-tag">
          {isPurchased ? (
            <span className="price-purchased"><FaCheckCircle /> Sotib olingan</span>
          ) : isFree ? (
            <span className="price-free">Bepul</span>
          ) : (
            <span className="price-amount">{formatSumma(narx)} tanga</span>
          )}
        </div>

        {kurs.video ? (
          <DarsVideoPlayer src={kurs.video} phoneNumber={userData ? (userData.ism || userData.tel || '') : ''} />
        ) : (
          <div className="black-video-placeholder"></div>
        )}

        <button
          className={`buyurtma-tugma ${isPurchased ? 'purchased-btn' : ''}`}
          onClick={onBuyClick}
          disabled={!isReady || isProcessing}
        >
          {isPurchased ? (
            <><FaCheckCircle className="icon-buyurtma" /> Kursga o'tish</>
          ) : (
            <><FaShoppingCart className="icon-buyurtma" /> {isFree ? "Kursga kirish" : "Sotib olish"}</>
          )}
        </button>
      </div>

      <CoursePurchaseModal
        isOpen={showPurchaseModal}
        onClose={() => setShowPurchaseModal(false)}
        onConfirm={handlePurchase}
        courseName={kurs.nomi}
        price={narx}
        kursId={kurs.id}
        isProcessing={isProcessing}
      />
    </div>
  );
}

export default Video;
